import React from 'react';
import AppClient from './AppClient';
import AppChauffeur from './AppChauffeur';
import MaintenanceGate from './MaintenanceGate';
import LegalGate from './LegalGate';
import PasswordGate from './PasswordGate';

function App() {
  const hostname = window.location.hostname;
  // REACT_APP_MODE=chauffeur force l'affichage chauffeur (ex : projet mbiyo-driver)
  const isChauffeur =
    process.env.REACT_APP_MODE === 'chauffeur' ||
    hostname.startsWith('chauffeur.');

  // Mode maintenance : enveloppe le site client ET le site chauffeur
  return (
    <MaintenanceGate>
      <LegalGate userType={isChauffeur ? 'driver' : 'user'}>
        <PasswordGate>
          {isChauffeur ? <AppChauffeur /> : <AppClient />}
        </PasswordGate>
      </LegalGate>
    </MaintenanceGate>
  );
}

export default App;
